import React from 'react';
import { useTranslation } from 'react-i18next';
import { Agent } from '../../../types';
import './AgentInfo.css';

interface AgentInfoProps {
  agent: Agent | null | undefined;
  title?: string;
}

export const AgentInfo: React.FC<AgentInfoProps> = ({ agent, title }) => {
  const { t } = useTranslation();

  if (!agent) {
    return null;
  }

  return (
    <section className="sidebar-section agent-info">
      <h3>{title || t('sidebar.agentInfo')}</h3>
      <div className="sidebar-grid">
        <div className="sidebar-field">
          <label>{t('sidebar.agentName')}</label>
          <input type="text" value={agent.name || ''} readOnly className="input-readonly" />
        </div>
        {agent.supportEmail && (
          <div className="sidebar-field">
            <label>{t('sidebar.supportEmail')}</label>
            <input type="text" value={agent.supportEmail} readOnly className="input-readonly" />
          </div>
        )}
        {agent.purchasingEmail && (
          <div className="sidebar-field">
            <label>{t('sidebar.purchasingEmail')}</label>
            <input type="text" value={agent.purchasingEmail} readOnly className="input-readonly" />
          </div>
        )}
        {agent.administrationEmail && (
          <div className="sidebar-field">
            <label>{t('sidebar.administrationEmail')}</label>
            <input type="text" value={agent.administrationEmail} readOnly className="input-readonly" />
          </div>
        )}
      </div>
    </section>
  );
};

export default AgentInfo;
